import { createPaginator } from "@smithy/core";
import { ListFacesCommand } from "../commands/ListFacesCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListFaces = createPaginator(RekognitionClient, ListFacesCommand, "NextToken", "NextToken", "MaxResults");
